export const SERVER_IMAGE_MIME_TYPES = ['image/webp', 'image/avif', 'image/heic', 'image/gif'];

export const SUPPORTED_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/tiff',
  ...SERVER_IMAGE_MIME_TYPES,
];
